import { AppThunk } from '../../../store/rootReducer';
import * as authActions from '../actions/auth.actions';
import * as preferencesClient from '../clients/preferences.client';
import { User } from '../types/auth';

export const loadPreferences =
  (user: User): AppThunk =>
  async (dispatch) => {
    const preferences = await preferencesClient.getPreferences(user.id);

    if (preferences == null) {
      return;
    }

    dispatch(
      authActions.setPreferences({ preferences, meta: { history: false } }),
    );
  };
